var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_744",
    "data-name": "Ellipse 744",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-15932 4003)",
    fill: "#c2cce1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-avatar_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar_5",
    clipPath: "url(#clip-avatar_5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613",
    transform: "translate(14680 -3439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_742",
    "data-name": "Ellipse 742",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-14680 3439)",
    fill: "#ffebd2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_43",
    "data-name": "Mask Group 43",
    transform: "translate(1252 -564)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man_2_",
    "data-name": "man(2)",
    transform: "translate(-15926 4006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18468",
    "data-name": "Path 18468",
    d: "M93.958,21.556v2.03a.414.414,0,0,1-.414.414h-15.1a.414.414,0,0,1-.414-.414v-2.03A3.857,3.857,0,0,1,81.886,17.7a2.142,2.142,0,0,0,1.8-.975,2.431,2.431,0,0,0,.344-1.516l.008-.019a5.121,5.121,0,0,1-3.163-4.732v-.162A1.276,1.276,0,0,1,79.58,9.025V6.876A7.159,7.159,0,0,1,81.5,1.651C83.72-.485,87.233-.311,89.778.832a.1.1,0,0,1,0,.19l-.664.273a.1.1,0,0,0,.028.2l.322.035a5.221,5.221,0,0,1,3.865,2.4.111.111,0,0,1-.013.128A3.129,3.129,0,0,0,92.458,6.2V9.025a1.269,1.269,0,0,1-1.269,1.269h-.076v.162a5.121,5.121,0,0,1-3.163,4.732l.008.019a2.43,2.43,0,0,0,.344,1.516,2.142,2.142,0,0,0,1.8.975A3.857,3.857,0,0,1,93.958,21.556Z",
    transform: "translate(-78.028 0)",
    fill: "#ffdfba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18469",
    "data-name": "Path 18469",
    d: "M93.958,328.2v2.03a.414.414,0,0,1-.414.414h-15.1a.414.414,0,0,1-.414-.414V328.2a3.858,3.858,0,0,1,3.858-3.857,2.142,2.142,0,0,0,1.8-.975,3.55,3.55,0,0,0,4.619,0,2.141,2.141,0,0,0,1.8.975A3.858,3.858,0,0,1,93.958,328.2Z",
    transform: "translate(-78.028 -306.642)",
    fill: "#fe4f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18470",
    "data-name": "Path 18470",
    d: "M121.735,3.927a.11.11,0,0,1-.013.127,3.131,3.131,0,0,0-.854,2.15V9.026a1.272,1.272,0,0,1-1.345,1.269V7.1a2.483,2.483,0,0,0-2.483-2.482h-5.275A2.482,2.482,0,0,0,109.282,7.1V10.3a1.276,1.276,0,0,1-1.293-1.269V6.877a7.159,7.159,0,0,1,1.924-5.225c2.217-2.137,5.73-1.962,8.274-.819a.1.1,0,0,1,0,.19l-.664.273a.1.1,0,0,0,.028.2l.322.035a5.218,5.218,0,0,1,3.864,2.4Z",
    transform: "translate(-106.438 0)",
    fill: "#42434d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18471",
    "data-name": "Path 18471",
    d: "M143.269,95.125a5.122,5.122,0,1,1-10.241-.162V91.768a2.482,2.482,0,0,1,2.483-2.482h5.275a2.482,2.482,0,0,1,2.483,2.482Z",
    transform: "translate(-130.183 -84.668)",
    fill: "#ffebd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18472",
    "data-name": "Path 18472",
    d: "M282.683,431.884h-1.241a.414.414,0,1,1,0-.827h1.241a.414.414,0,1,1,0,.827Z",
    transform: "translate(-270.529 -408.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18473",
    "data-name": "Path 18473",
    d: "M136.989,113.274a.818.818,0,0,1-.744,1.448,5.121,5.121,0,0,1-3.217-4.755v-3.356a2.472,2.472,0,0,1,.436-1.405.611.611,0,0,1,1.116.371v3.356A5.083,5.083,0,0,0,136.989,113.274Z",
    transform: "translate(-130.183 -99.512)",
    fill: "#fff3e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18474",
    "data-name": "Path 18474",
    d: "M196.946,294.554a5.135,5.135,0,0,1-4.048,0,3.205,3.205,0,0,0,.058-.849l.008-.019a5.13,5.13,0,0,0,3.915,0l.008.019A3.2,3.2,0,0,0,196.946,294.554Z",
    transform: "translate(-186.957 -278.497)",
    fill: "#ffd6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18475",
    "data-name": "Path 18475",
    d: "M83.97,325.591a2.1,2.1,0,0,1-.616.1,3.868,3.868,0,0,0-3.877,3.843v.389a.724.724,0,0,1-.724.724h-.31a.414.414,0,0,1-.414-.414V328.2a3.858,3.858,0,0,1,3.858-3.857,2.141,2.141,0,0,0,1.8-.975,3.587,3.587,0,0,0,.492.353A1.033,1.033,0,0,1,83.97,325.591Z",
    transform: "translate(-78.028 -306.642)",
    fill: "#ff6d7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18476",
    "data-name": "Path 18476",
    d: "M258.073,325.591a2.1,2.1,0,0,0,.616.1,3.868,3.868,0,0,1,3.877,3.843v.389a.724.724,0,0,0,.724.724h.31a.414.414,0,0,0,.414-.414V328.2a3.858,3.858,0,0,0-3.858-3.857,2.141,2.141,0,0,1-1.8-.975,3.582,3.582,0,0,1-.492.353A1.033,1.033,0,0,0,258.073,325.591Z",
    transform: "translate(-248.085 -306.642)",
    fill: "#e84857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18477",
    "data-name": "Path 18477",
    d: "M118.184,1.023c-.608.25-.695.305-.906.273-3.4-.526-6.377.879-7.389,4.178h0a2.47,2.47,0,0,0-.607,1.626V9.041a.647.647,0,1,1-1.293-.015V6.876a7.159,7.159,0,0,1,1.924-5.225c2.217-2.136,5.73-1.962,8.274-.819a.1.1,0,0,1,0,.19Z",
    transform: "translate(-106.438 0)",
    fill: "#4d4e59"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar_5.fdbc2821cd881b50f0f4d085ecc9b936.svg";
export { ForwardRef as ReactComponent };